/**
 * 根据屏幕宽度和高度计算元素高度
 * @param {number} width - 屏幕宽度
 * @param {number} height - 屏幕高度
 * @param {number} aspectWidth - 宽高比中的宽 (默认: 9)
 * @param {number} aspectHeight - 宽高比中的高 (默认: 16)
 * @returns {Object} { indexHeight: string, stepHeight: string, isCompact: boolean  }
 */
export function calculateHeights(
  width,
  height,
  aspectWidth = 9,
  aspectHeight = 16
) {
  const desiredHeight = (width * aspectHeight) / aspectWidth;

  let indexHeight, stepHeight, isCompact = false;
console.log("desiredHeight:", desiredHeight, "height - 2:", height - 2);

  if (desiredHeight >= height - 2) {
    indexHeight = "96%";
    stepHeight = "4%";
    isCompact = true; // 需要紧凑样式
  } else {
    indexHeight = `${desiredHeight}px`;
    stepHeight = `${height - desiredHeight}px`;
  }

  return {
    indexHeight,
    stepHeight,
    isCompact,
  };
}

/**
 * 应用计算的高度到 DOM 节点
 */
export function applyHeights() {
  const { innerWidth, innerHeight } = window;
  const { indexHeight, stepHeight, isCompact } = calculateHeights(innerWidth, innerHeight);

  // 设置 .index 的高度
  const indexElement = document.querySelector(".index");
  if (indexElement) {
    indexElement.style.setProperty("height", indexHeight, "important");
  }

  // 设置 .step 的高度
  const stepElement = document.querySelector(".step_box");
  
  if (stepElement) {
    stepElement.style.setProperty("height", stepHeight, "important");
  }

  // 动态调整 .stepBox_item 样式
  const stepBoxItems = document.querySelectorAll(".stepBox_item");
  stepBoxItems.forEach((item) => {
    if (isCompact) {
      item.style.fontSize = "15px !important";
    } else {
    }
  });

  // 动态调整 .step_num 样式
  const stepNums = document.querySelectorAll(".step_num");
  stepNums.forEach((num) => {
    if (isCompact) {
      num.style.width = "18px !important";
      num.style.height = "18px !important";
    } else {
    }
  });
}
export function stepBoxHeight() {
  const { innerWidth, innerHeight } = window;
  const { indexHeight, stepHeight, isCompact } = calculateHeights(innerWidth, innerHeight);

  // 设置 .index 的高度

  // 设置 .step 的高度
  const stepElement = document.querySelector(".step_box");
  
  if (stepElement) {
    stepElement.style.setProperty("height", stepHeight, "important");
  }

  // 动态调整 .stepBox_item 样式
  const stepBoxItems = document.querySelectorAll(".stepBox_item");
  stepBoxItems.forEach((item) => {
    if (isCompact) {
      item.style.fontSize = "15px !important";
    } else {
    }
  });

  // 动态调整 .step_num 样式
  const stepNums = document.querySelectorAll(".step_num");
  stepNums.forEach((num) => {
    if (isCompact) {
      num.style.width = "18px !important";
      num.style.height = "18px !important";
    } else {
    }
  });
}
